<template>
  <v-container id="group-list">
    <city-header :payload="payload"> </city-header>

    <v-row>
      <v-col>Grupos</v-col>
      <v-col class="text-right">
        <app-modal-insert-group
          v-if="isFullAdmin || (groupsConfig.novoGrupo && config.novoGrupo)"
          :edit="false"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          :municipioId="payload.municipioId"
          @on-save="loadGroups"
        >
          <template v-slot:title :edit="false">
            Cadastramento de Grupo
          </template>
        </app-modal-insert-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.grupos"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              <a
                :href="
                  '#/cidade/' + payload.municipioId + '/grupo/' + item.grupoId
                "
              >
                {{ item.nome }}
              </a>
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-group
                  v-if="isAdmin || isSPFespEspecial"
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :municipioId="payload.municipioId"
                  @on-save="loadGroups"
                >
                  <template v-slot:title>
                    Edição de Grupo
                  </template>
                </app-modal-insert-group>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span>
              Nenhum grupo retornado
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "../Header";
import AppModalInsertGroup from "./ModalInsert";
import { groupAPI } from "../GroupAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CityHeader,
    AppModalInsertGroup
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome" },
        { text: "Descrição", value: "descricao" },
        { text: "Ações", value: "acoes", sortable: false }
      ],
      payload: {
        municipioId: this.$route.params.id
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig"))
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio"
    ]),
    loadGroups() {
      this.setLoading(true);
      groupAPI
        .get(this.$route.params.id)
        .then(resp => {
          this.payload = resp.data;
          this.setLoading(false);
        })
        .catch(resp => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter grupos");
        });
    }
  },
  mounted() {
    this.loadGroups();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAnalistaMunicipio",
      "isAuthenticated",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin"
    ])
  }
};
</script>
